import React, { Fragment } from 'react';
import If from 'src/components/Shared/If/If';
import Phone from 'src/components/Shared/Phone/Phone';
import {
  COLLEGE_FUND_NOTE_CANNOT_LINK_BANK_FORM_URL,
  COLLEGE_FUND_NOTE_PHONE_NUMBERS,
  FundNoteCollege,
  TOLL_FREE_NUMBER,
} from 'src/settings/settings';
import { coalesce } from 'src/utils/utils';
import AddressUndeliverableFundNoteTip from './AddressUndeliverableFundNoteTip';
import FundNote from './FundNote';
import './FundNote.module.scss';
import PendingTransactionFundNoteTip from './PendingTransactionFundNoteTip';
import RestrictedCountryFundNoteTip from './RestrictedCountryFundNoteTip';
import SignatureRequiredFundNoteTip from './SignatureRequiredFundNoteTip';

const CollegeContributeFundNotes = ({ fund }) => {
  const phoneNumber = coalesce(
    COLLEGE_FUND_NOTE_PHONE_NUMBERS[fund.productType],
    TOLL_FREE_NUMBER
  );
  return (
    <Fragment>
      <If test={fund.notes[FundNoteCollege.COUNTRY_RESTRICTED]}>
        <FundNote
          labelSubText="Requires Permanent US Address"
          labelText="Restricted"
          tipHeader="Restricted Country"
          tipMessage={<RestrictedCountryFundNoteTip />}
        />
      </If>
      <If test={fund.notes[FundNoteCollege.STOP_PURCHASE]}>
        <FundNote
          labelSubText=""
          labelText="Stop Purchase Applied"
          tipHeader="Stop Purchase"
          tipMessage={
            <div className="exclude">
              This portfolio or account is unavailable for purchase. Please
              contact us at <Phone phoneNumber={phoneNumber} />.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteCollege.CANNOT_LINK_BANK]}>
        <FundNote
          labelSubText="Signature Required"
          labelText="Cannot Link Bank"
          tipHeader="Cannot Link Bank"
          tipMessage={
            <SignatureRequiredFundNoteTip
              formUrl={
                COLLEGE_FUND_NOTE_CANNOT_LINK_BANK_FORM_URL[fund.productType]
              }
            />
          }
        />
      </If>
      <If test={fund.notes[FundNoteCollege.ONLINE_PURCHASE_RESTRICTED]}>
        <FundNote
          labelSubText=""
          labelText="Unavailable for Purchase Online"
          tipHeader="Unavailable for Purchase Online"
          tipMessage={
            <div className="exclude">
              Online/phone purchase disabled. Call{' '}
              <Phone phoneNumber={phoneNumber} /> to enable purchasing.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteCollege.PENDING]}>
        <FundNote
          labelSubText=""
          labelText="Transaction Pending"
          tipHeader="Transaction Pending"
          tipMessage={<PendingTransactionFundNoteTip />}
        />
      </If>
      <If test={fund.notes[FundNoteCollege.ADDRESS_UNDELIVERABLE]}>
        <FundNote
          labelSubText=""
          labelText="Address Undeliverable"
          tipHeader="Address Undeliverable"
          tipMessage={
            <AddressUndeliverableFundNoteTip phoneNumber={phoneNumber} />
          }
        />
      </If>
    </Fragment>
  );
};

export default CollegeContributeFundNotes;
